import React, { useState, useEffect } from "react";
import { uploadUrl } from "../uploadUrl";

// Circular photo avatar — every employee/candidate photo across the app
// renders through here, so this one component sets the look for all of
// them. `src` failing to load (a stale/500'd upload path — the single
// biggest cause of the blank outline-only avatars this replaces) falls
// back to the initials tile instead of an empty bordered circle, via the
// same onError-tracked-in-state pattern used for the sidebar logo.
export const Av = ({ nm, sz = 36, rn, src }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  const i = (nm || "?").split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
  const h = nm ? [...nm].reduce((a, c) => a + c.charCodeAt(0), 0) : 0;
  // Two lightness stops of the same hue, not an alpha suffix appended to the
  // hsl() string (`${bg}BB`/`${bg}30`, as this used to do) — hex-alpha
  // syntax only applies to #RRGGBB colors, not hsl(); appending it to hsl()
  // is invalid CSS, and the browser silently drops the whole declaration
  // rather than erroring, which is why every avatar without a photo has
  // always rendered as a hollow, texture-less ring instead of a filled
  // initials tile.
  const bg = `hsl(${h % 360},48%,42%)`;
  const bgLight = `hsl(${h % 360},48%,54%)`;
  const borderTint = `hsla(${h % 360},48%,42%,.35)`;
  if (src && !failed)
    return <img
      src={src.startsWith("http") ? src : uploadUrl(src)}
      alt={nm}
      onError={() => setFailed(true)}
      className="object-cover flex-shrink-0 rounded-full"
      style={{ width: sz, height: sz, minWidth: sz, border: rn ? `2px solid ${rn}` : `2px solid ${borderTint}` }}
    />;
  return <div
    className="flex items-center justify-center font-bold text-white flex-shrink-0 rounded-full"
    style={{ width: sz, height: sz, minWidth: sz, background: `linear-gradient(145deg,${bgLight},${bg})`, fontSize: sz * .38, border: rn ? `2px solid ${rn}` : `2px solid ${borderTint}` }}
  >{i}</div>;
};
